import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./Materialcatalog.scss";

// Components
import Layout from "../../../Layout/Layout";
import StarRating from "./StarRating";
import { ComboboxField } from "../../../Components/formElements/ComboboxField";
import { InputField } from "../../../Components/formElements/InputField";
import CatalogMaterialDetailsModal from "./CatalogMaterialDetailsModal";
import toast from "react-hot-toast";
import MatrialCreatePo from "./MatrialCreatePoShopwise";
import { Modal } from "react-bootstrap";
import { Trash2 } from "lucide-react";

// Import manuData
import { shopBycategori } from "./MenueData";

let sortDropDown = [
  { id: "1", name: "Default Sorting" },
  { id: "2", name: "Sort by Popularity" },
  { id: "3", name: "Sort by price: Low to High" },
  { id: "4", name: "Sort by price: High to Low" },
];

let pagination = [
  { id: "1", name: "5" },
  { id: "2", name: "10" },
  { id: "3", name: "15" },
];


const hardcodedProducts  = [
  {
    id: 1,
    productName: "ISI-marked Helmets",
    productNumber: "PRD001",
    category: "Rider Gear",
    subCategory: "Rider Gear",
    stock: 1000,
    sold: 120,
    views: 490,
    price: 528,
    uom: "EA",
    // discount: 0,
    // discountedPrice: 528,
    description: "Rider safety",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 3.8,
    reviews: 11,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/image1.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "Not Applicable",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: true,
    seasonal: false,
    bestseller: false,
  },

  {
    id: 2,
    productName: "Reflective Safety Jackets",
    productNumber: "PRD002",
    category: "Rider Gear",
    subCategory: "Rider Gear",
    stock: 100,
    sold: 73,
    views: 369,
    price: 1164,
    uom: "EA",
    // discount: 0,
    // discountedPrice: 1164,
    description: "Night visibility",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 3.8,
    reviews: 43,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/jocket2.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "Not Applicable",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: true,
    seasonal: false,
    bestseller: false,
  },

  {
    id: 3,
    productName: "Riding Raincoats (2-piece / full suit)",
    productNumber: "PRD003",
    category: "Rider Gear",
    subCategory: "Rider Gear",
    stock: 1000,
    sold: 216,
    views: 1868,
    price: 1449,
    uom: "EA",
    // discount: 5,
    // discountedPrice: 1376,
    description: "Monsoon operations",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 4.3,
    reviews: 19,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/raincotes.webp",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "Not Applicable",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: false,
    seasonal: false,
    bestseller: true,
  },

  {
    id: 4,
    productName: "Rider Gloves",
    productNumber: "PRD004",
    category: "Rider Gear",
    subCategory: "Rider Gear",
    stock: 200,
    sold: 228,
    views: 1321,
    price: 869,
    uom: "EA",
    // discount: 0,
    // discountedPrice: 869,
    description: "Comfort & grip",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 4.0,
    reviews: 14,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/glows3.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "Not Applicable",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: true,
    seasonal: false,
    bestseller: true,
  },

  {
    id: 5,
    productName: "Safety Shoes / Riding Shoes",
    productNumber: "PRD005",
    category: "Rider Gear",
    subCategory: "Rider Gear",
    stock: 100,
    sold: 147,
    views: 492,
    price: 989,
    uom: "EA",
    // discount: 0,
    // discountedPrice: 989,
    description: "Protection & comfort",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 4.0,
    reviews: 27,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/rideshooes.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "Not Applicable",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: false,
    seasonal: false,
    bestseller: false,
  },

  {
    id: 6,
    productName: "Insulated Delivery Bags (S/M/L)",
    productNumber: "PRD006",
    category: "Rider Accessories",
    subCategory: "Rider Accessories",
    stock: 500,
    sold: 187,
    views: 629,
    price: 377,
    uom: "EA",
    // discount: 25,
    // discountedPrice: 282,
    description: "Grocery & food delivery",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 5.0,
    reviews: 29,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/Bag.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "Not Applicable",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: true,
    seasonal: false,
    bestseller: false,
  },

  {
    id: 7,
    productName: "Hard Shell Delivery Box (rear-mounted)",
    productNumber: "PRD007",
    category: "Rider Accessories",
    subCategory: "Rider Accessories",
    stock: 1000,
    sold: 208,
    views: 1156,
    price: 2461,
    uom: "EA",
    // discount: 10,
    // discountedPrice: 2214,
    description: "High-volume delivery",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 4.4,
    reviews: 50,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/Box.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "Not Applicable",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: true,
    seasonal: false,
    bestseller: true,
  },

  {
    id: 8,
    productName: "Mobile Holder for Bikes",
    productNumber: "PRD008",
    category: "Rider Accessories",
    subCategory: "Rider Accessories",
    stock: 200,
    sold: 247,
    views: 1086,
    price: 387,
    uom: "EA",
    // discount: 25,
    // discountedPrice: 290,
    description: "Navigation support",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 5.0,
    reviews: 19,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/mobile1.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "Not Applicable",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: true,
    seasonal: false,
    bestseller: true,
  },

  {
    id: 9,
    productName: "Power Banks",
    productNumber: "PRD009",
    category: "Rider Accessories",
    subCategory: "Rider Accessories",
    stock: 500,
    sold: 212,
    views: 1171,
    price: 1756,
    uom: "EA",
    // discount: 10,
    // discountedPrice: 1580,
    description: "Backup for rider phones",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 3.7,
    reviews: 27,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/bank.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "Not Applicable",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: true,
    seasonal: false,
    bestseller: true,
  },

  {
    id: 10,
    productName: "Plastic Crates (various sizes)",
    productNumber: "PRD010",
    category: "Storage",
    subCategory: "Storage",
    stock: 1000,
    sold: 215,
    views: 576,
    price: 423,
    uom: "EA",
    // discount: 25,
    // discountedPrice: 317,
    description: "Order picking & storage",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 4.4,
    reviews: 15,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/cart.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "Not Applicable",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: true,
    seasonal: false,
    bestseller: true,
  },

  {
    id: 11,
    productName: "Tote Bins with/without Lids",
    productNumber: "PRD011",
    category: "Storage",
    subCategory: "Storage",
    stock: 500,
    sold: 119,
    views: 1185,
    price: 317,
    uom: "EA",
    // discount: 15,
    // discountedPrice: 269,
    description: "Segregation & transfer",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 4.5,
    reviews: 40,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/dust.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "Not Applicable",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: true,
    seasonal: false,
    bestseller: false,
  },

  {
    id: 12,
    productName: "Platform Trolleys",
    productNumber: "PRD012",
    category: "Handling",
    subCategory: "Handling",
    stock: 100,
    sold: 108,
    views: 1057,
    price: 12716,
    uom: "EA",
    // discount: 10,
    // discountedPrice: 11444,
    description: "In-store movement",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 3.5,
    reviews: 25,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/trolley.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "6 months",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: false,
    seasonal: false,
    bestseller: false,
  },

  {
    id: 13,
    productName: "Hand Pallet Trucks",
    productNumber: "PRD013",
    category: "Handling",
    subCategory: "Handling",
    stock: 200,
    sold: 283,
    views: 1854,
    price: 5886,
    uom: "EA",
    // discount: 0,
    // discountedPrice: 5886,
    description: "Moving heavy loads",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 3.8,
    reviews: 36,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/tru.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "6 months",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: false,
    seasonal: false,
    bestseller: true,
  },

  {
    id: 14,
    productName: "Step Ladders (3–5 steps)",
    productNumber: "PRD014",
    category: "Handling",
    subCategory: "Handling",
    stock: 200,
    sold: 117,
    views: 376,
    price: 12032,
    uom: "EA",
    // discount: 15,
    // discountedPrice: 10227,
    description: "Access higher racks",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 3.9,
    reviews: 40,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/lad.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "6 months",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: false,
    seasonal: false,
    bestseller: false,
  },
  {
    id: 15,
    productName: "Paper Carry Bags (S/M/L)",
    productNumber: "PRD015",
    category: "Carry & Delivery",
    subCategory: "Carry & Delivery",
    stock: 500,
    sold: 279,
    views: 2193,
    price: 482,
    uom: "PKT",
    // discount: 20,
    // discountedPrice: 385,
    description: "Customer handover",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 4.0,
    reviews: 13,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/bag1.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "Not Applicable",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: false,
    seasonal: false,
    bestseller: true,
  },

  {
    id: 16,
    productName: "Polybags (LD/HD) with/without Print",
    productNumber: "PRD016",
    category: "Carry & Delivery",
    subCategory: "Carry & Delivery",
    stock: 100,
    sold: 89,
    views: 820,
    price: 146,
    uom: "PKT",
    // discount: 0,
    // discountedPrice: 146,
    description: "Order packing",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 3.7,
    reviews: 48,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/polybags.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "Not Applicable",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: false,
    seasonal: false,
    bestseller: false,
  },

  {
    id: 17,
    productName: "Bubble Roll",
    productNumber: "PRD017",
    category: "Protection",
    subCategory: "Protection",
    stock: 500,
    sold: 202,
    views: 1362,
    price: 265,
    uom: "ROLL",
    // discount: 15,
    // discountedPrice: 225,
    description: "Fragile item protection",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 4.3,
    reviews: 40,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/rol1.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "Not Applicable",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: true,
    seasonal: false,
    bestseller: true,
  },

  {
    id: 18,
    productName: "Foam Sheets / Rolls",
    productNumber: "PRD018",
    category: "Protection",
    subCategory: "Protection",
    stock: 750,
    sold: 242,
    views: 1030,
    price: 317,
    uom: "ROLL",
    // discount: 25,
    // discountedPrice: 237,
    description: "Cushioning items",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 4.7,
    reviews: 26,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/foam.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "Not Applicable",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: true,
    seasonal: false,
    bestseller: true,
  },

  {
    id: 19,
    productName: "Brown BOPP Tape (48/72 mm)",
    productNumber: "PRD019",
    category: "Tapes",
    subCategory: "Tapes",
    stock: 200,
    sold: 166,
    views: 338,
    price: 87,
    uom: "ROLL",
    // discount: 15,
    // discountedPrice: 73,
    description: "Carton sealing",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 4.9,
    reviews: 21,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/tap.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "Not Applicable",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: true,
    seasonal: false,
    bestseller: false,
  },

  {
    id: 20,
    productName: "PP Strapping Roll",
    productNumber: "PRD020",
    category: "Strapping",
    subCategory: "Strapping",
    stock: 1000,
    sold: 126,
    // views: 1113,
    price: 279,
    uom: "ROLL",
    // discount: 0,
    // discountedPrice: 279,
    description: "Carton bundling",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 4.5,
    reviews: 43,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/sta.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "Not Applicable",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: true,
    seasonal: false,
    bestseller: false,
  },

  {
    id: 21,
    productName: "Stretch Film – Manual Roll",
    productNumber: "PRD021",
    category: "Strapping",
    subCategory: "Strapping",
    stock: 200,
    sold: 188,
    views: 1462,
    price: 189,
    uom: "ROLL",
    // discount: 10,
    // discountedPrice: 170,
    description: "Pallet wrapping",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 4.9,
    reviews: 43,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/ldpe.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "Not Applicable",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: false,
    seasonal: false,
    bestseller: false,
  },

  {
    id: 22,
    productName: "Thermal Labels (various sizes)",
    productNumber: "PRD022",
    category: "Labels",
    subCategory: "Labels",
    stock: 100,
    sold: 287,
    views: 2060,
    price: 225,
    uom: "ROLL",
    // discount: 0,
    // discountedPrice: 225,
    description: "Order & shipping labels",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 4.8,
    reviews: 24,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/labels.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "Not Applicable",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: true,
    seasonal: false,
    bestseller: true,
  },

  {
    id: 23,
    productName: "Safety Helmets",
    productNumber: "PRD023",
    category: "PPE",
    subCategory: "PPE",
    stock: 750,
    sold: 292,
    views: 906,
    price: 218,
    uom: "EA",
    // discount: 5,
    // discountedPrice: 207,
    description: "Store / hub safety",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 3.6,
    reviews: 36,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/saftey.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "Not Applicable",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      // cost: "₹50",
    },
    featured: true,
    seasonal: false,
    bestseller: true,
  },

  {
    id: 24,
    productName: "High-Visibility Jackets",
    productNumber: "PRD024",
    category: "PPE",
    subCategory: "PPE",
    stock: 200,
    sold: 218,
    views: 1409,
    price: 1190,
    uom: "EA",
    // discount: 5,
    // discountedPrice: 1130,
    description: "Outdoor & night ops",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 4.9,
    reviews: 15,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/jackets.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "Not Applicable",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: false,
    seasonal: false,
    bestseller: true,
  },

  {
    id: 25,
    productName: "Nitrile / Latex Disposable Gloves",
    productNumber: "PRD025",
    category: "PPE",
    subCategory: "PPE",
    stock: 500,
    sold: 296,
    views: 1459,
    price: 1180,
    uom: "PKT",
    // discount: 20,
    // discountedPrice: 944,
    description: "Food & hygiene handling",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 4.9,
    reviews: 49,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/nitro.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "Not Applicable",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: true,
    seasonal: false,
    bestseller: true,
  },

  {
    id: 26,
    productName: "Cut-Resistant Gloves",
    productNumber: "PRD026",
    category: "PPE",
    subCategory: "PPE",
    stock: 1000,
    sold: 216,
    views: 1196,
    price: 738,
    uom: "PKT",
    // discount: 15,
    // discountedPrice: 627,
    description: "Handling sharp objects",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 4.2,
    reviews: 38,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/cuts.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "Not Applicable",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: false,
    seasonal: false,
    bestseller: true,
  },

  {
    id: 27,
    productName: "Safety Shoes / Gumboots",
    productNumber: "PRD027",
    category: "PPE",
    subCategory: "PPE",
    stock: 200,
    sold: 66,
    views: 478,
    price: 347,
    uom: "EA",
    // discount: 5,
    // discountedPrice: 329,
    description: "Wet & heavy-duty areas",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 3.5,
    reviews: 40,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/boo.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "Not Applicable",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: true,
    seasonal: false,
    bestseller: false,
  },

  {
    id: 28,
    productName: "First Aid Kits (Refillable)",
    productNumber: "PRD028",
    category: "Safety Accessories",
    subCategory: "Safety Accessories",
    stock: 100,
    sold: 231,
    views: 1754,
    price: 2304,
    uom: "EA",
    // discount: 0,
    // discountedPrice: 2304,
    description: "Emergency care",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 3.6,
    reviews: 9,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/med.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "6 months",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: true,
    seasonal: false,
    bestseller: true,
  },

  {
    id: 29,
    productName: "Fire Extinguishers (ABC / CO₂)",
    productNumber: "PRD029",
    category: "Safety Accessories",
    subCategory: "Safety Accessories",
    stock: 750,
    sold: 110,
    views: 505,
    price: 3206,
    uom: "EA",
    // discount: 0,
    // discountedPrice: 3206,
    description: "Fire safety compliance",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 4.5,
    reviews: 18,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/co.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "6 months",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: true,
    seasonal: false,
    bestseller: false,
  },

  {
    id: 30,
    productName: "Safety Signage Boards",
    productNumber: "PRD030",
    category: "Safety Accessories",
    subCategory: "Safety Accessories",
    stock: 500,
    sold: 256,
    views: 2179,
    price: 4372,
    uom: "EA",
    // discount: 5,
    // discountedPrice: 4153,
    description: "Compliance & guidance",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 3.8,
    reviews: 11,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/warn.png",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "6 months",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: false,
    seasonal: false,
    bestseller: true,
  },

  {
    id: 31,
    productName: "Mops (Dry/Wet)",
    productNumber: "PRD031",
    category: "Cleaning Tools",
    subCategory: "Cleaning Tools",
    stock: 500,
    sold: 169,
    views: 448,
    price: 281,
    uom: "EA",
    // discount: 15,
    // discountedPrice: 238,
    description: "Floor cleaning",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 4.5,
    reviews: 46,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/wet.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "Not Applicable",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: true,
    seasonal: false,
    bestseller: false,
  },

  {
    id: 32,
    productName: "Mop Buckets with Wringer",
    productNumber: "PRD032",
    category: "Cleaning Tools",
    subCategory: "Cleaning Tools",
    stock: 1000,
    sold: 136,
    views: 495,
    price: 131,
    uom: "EA",
    // discount: 15,
    // discountedPrice: 111,
    description: "Wet mopping",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 3.9,
    reviews: 17,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/mind.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "Not Applicable",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: false,
    seasonal: false,
    bestseller: false,
  },

  {
    id: 33,
    productName: "Brooms (Soft/Hard)",
    productNumber: "PRD033",
    category: "Cleaning Tools",
    subCategory: "Cleaning Tools",
    stock: 200,
    sold: 121,
    views: 715,
    price: 171,
    uom: "EA",
    // discount: 15,
    // discountedPrice: 145,
    description: "Sweeping",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 3.9,
    reviews: 9,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/broom.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "Not Applicable",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: false,
    seasonal: false,
    bestseller: false,
  },

  {
    id: 34,
    productName: "Floor Cleaner (Disinfectant)",
    productNumber: "PRD034",
    category: "Cleaning Chemicals",
    subCategory: "Cleaning Chemicals",
    stock: 100,
    sold: 62,
    views: 457,
    price: 563,
    uom: "LTR",
    // discount: 20,
    // discountedPrice: 450,
    description: "Store & hub floors",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 5.0,
    reviews: 5,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/poly.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "Not Applicable",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: true,
    seasonal: false,
    bestseller: false,
  },

  {
    id: 35,
    productName: "Toilet Cleaner",
    productNumber: "PRD035",
    category: "Cleaning Chemicals",
    subCategory: "Cleaning Chemicals",
    stock: 200,
    sold: 154,
    views: 1302,
    price: 535,
    uom: "LTR",
    // discount: 5,
    // discountedPrice: 508,
    description: "Washrooms",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 4.2,
    reviews: 30,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/har.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "Not Applicable",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: true,
    seasonal: false,
    bestseller: false,
  },

  {
    id: 36,
    productName: "Garbage Bags (S/M/L/XL)",
    productNumber: "PRD036",
    category: "Hygiene",
    subCategory: "Hygiene",
    stock: 100,
    sold: 149,
    views: 841,
    price: 368,
    uom: "PKT",
    // discount: 15,
    // discountedPrice: 312,
    description: "Waste segregation",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 4.9,
    reviews: 34,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/gar.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "Not Applicable",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: false,
    seasonal: false,
    bestseller: false,
  },

  {
    id: 37,
    productName: "Color-coded Dustbins",
    productNumber: "PRD037",
    category: "Hygiene",
    subCategory: "Hygiene",
    stock: 1000,
    sold: 250,
    views: 1638,
    price: 633,
    uom: "EA",
    // discount: 25,
    // discountedPrice: 474,
    description: "Dry/wet/hazardous waste",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 4.5,
    reviews: 36,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/dusta.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "Not Applicable",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: true,
    seasonal: false,
    bestseller: true,
  },

  {
    id: 38,
    productName: "Hand Wash & Sanitiser (Bulk)",
    productNumber: "PRD038",
    category: "Hygiene",
    subCategory: "Hygiene",
    stock: 200,
    sold: 297,
    views: 833,
    price: 394,
    uom: "LTR",
    // discount: 10,
    // discountedPrice: 354,
    description: "Staff hygiene",
    vendor: "Byyizzy",
    vendorLocation: "India",
    rating: 4.4,
    reviews: 39,
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
    availability: "In Stock",
    imageUrl: "/assets/img/catlog_image/sani.jpg",
    createdAt: "2025-01-01",
    updatedAt: "2025-01-10",
    tags: [],
    warranty: "Not Applicable",
    returnPolicy: "Return within 7 days if unused",
    shipping: {
      availableRegions: ["India"],
      estimatedDelivery: "3-5 business days",
      cost: "₹50",
    },
    featured: true,
    seasonal: false,
    bestseller: true,
  },
];


const MaterialCatalogShopwise = () => {
  localStorage.setItem("menu", "Catalog Manage");
  localStorage.setItem("submenu", "Matetial Shop");

  const location = useLocation();
  const categoryPath = location.state?.categoryPath;

  // State Management
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [categoryTitle, setCategoryTitle] = useState("");
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [getToggle, setToggle] = useState(true);
  const [showCartModal, setShowCartModal] = useState(false);
  const [cartItems, setCartItems] = useState(() => {
    const saved = localStorage.getItem("materialcart");
    return saved ? JSON.parse(saved) : [];
  });
  const [qtyMap, setQtyMap] = useState({});
  const [modalShowDetailProduct, setModalShowDetailProduct] = useState(false);
  const [modalProduct, setModalProduct] = useState(null);
  const [equipmentData, setEquipmentData] = useState(null);
  const [modalShowPurchase, setModalShowPurchase] = useState(false);
  const [openFromCart, setOpenFromCart] = useState(false);
  const [openCategory, setOpenCategory] = useState(null);

  // OLD CATEGORIES
  const oldCategories = [
    {
      name: "Rider Operations",
      items: ["Rider Gear", "Rider Accessories"],
    },
    {
      name: "Dark Store Handling",
      items: ["Storage", "Handling"],
    },
    {
      name: "Packaging Dispatch",
      items: ["Carry & Delivery", "Protection", "Tapes", "Strapping", "Labels"],
    },
    {
      name: "Safety PPE",
      items: ["PPE", "Safety Accessories"],
    },
    {
      name: "Housekeeping Hygiene",
      items: ["Cleaning Tools", "Cleaning Chemicals", "Hygiene"],
    },
  ];

  // LOAD DATA
  useEffect(() => {
    if (categoryPath) {
      const categoryData = shopBycategori.find(
        (cat) => cat.path === categoryPath
      );

      if (categoryData) {
        const convertedProducts = categoryData.product.map((item, idx) => ({
          id: idx + 1,
          productName: item.metrialName,
          productNumber: item.metrialCode,
          category: item.category,
          subCategory: item.category,
          price: item.price,
          imageUrl: item.image,
          description: item.details,
          rating: 4.0,
          reviews: 0,
          uom: "EA",
          stock: 100,
          sold: 0,
          views: 0,
          vendor: "Byyizzy",
          vendorLocation: "India",
          availability: "In Stock",
          weight: "N/A",
          dimensions: "N/A",
          color: "N/A",
          material: "N/A",
          careInstructions: "N/A",
          warranty: "Not Applicable",
          returnPolicy: "Return within 7 days if unused",
          shipping: {
            availableRegions: ["India"],
            estimatedDelivery: "3-5 business days",
            cost: "₹50",
          },
          featured: false,
          seasonal: false,
          bestseller: false,
        }));

        setProducts(convertedProducts);
        setCategories(categoryData.categories || []);
        setCategoryTitle(categoryData.title || "");
        setFilteredProducts(convertedProducts);
      }
    } else {
      setProducts(hardcodedProducts);
      setCategories(oldCategories);
      setCategoryTitle("Browse materials");
      setFilteredProducts(hardcodedProducts);
    }
    // eslint-disable-next-line 
  }, [categoryPath]);

  // Save cart
  useEffect(() => {
    localStorage.setItem("materialcart", JSON.stringify(cartItems));
  }, [cartItems]);

  // Handle subcategory filter
  const handleSubcategoryClick = (subcategory) => {
    setSelectedSubcategory(subcategory);
    if (subcategory === "All") {
      setFilteredProducts(products);
    } else {
      const filtered = products.filter(
        (product) =>
          product.category === subcategory ||
          product.subCategory === subcategory
      );
      setFilteredProducts(filtered);
    }
  };

  const clearFilter = () => {
    setSelectedSubcategory(null);
    setFilteredProducts(products);
  };

  const toggleRowProduct = () => setToggle(true);
  const toggleColProduct = () => setToggle(false);

  const handleAddToCart = (product, qty = 1) => {
    let action = "add";
    setCartItems((prev) => {
      const exists = prev.find(
        (p) => p.productNumber === product.productNumber
      );
      if (exists) {
        action = "update";
        return prev.map((p) =>
          p.productNumber === product.productNumber
            ? { ...p, qty: p.qty + qty }
            : p
        );
      }
      return [...prev, { ...product, qty }];
    });

    if (action === "update") {
      toast.success(`${product.productName} quantity updated`, {
        position: "top-right",
      });
    } else {
      toast.success(`${product.productName} added to cart`, {
        position: "top-right",
      });
    }
  };

  const handleRemoveFromCart = (item) => {
    setCartItems((prev) =>
      prev.filter((p) => p.productNumber !== item.productNumber)
    );
    toast.error(`${item.productName} removed from cart`, {
      position: "top-right",
    });
  };

  const showProductDetail = (product) => {
    setModalShowDetailProduct(true);
    setModalProduct(product);
  };

  const hideModal = () => {
    setModalShowDetailProduct(false);
    setModalShowPurchase(false);
  };

  const equipmentDetails = (data) => {
    setEquipmentData(data);
    setModalShowPurchase(true);
  };

  const handleCategoryClick = (categoryName) => {
    setOpenCategory(openCategory === categoryName ? null : categoryName);
  };

  // RENDER CATEGORIES
  const renderCategories = () => {
    if (categoryPath) {
      return (
        <ul className="list-unstyled">
          {categories.map((category, index) => (
            <li
              key={index}
              className={`subcategory ${
                selectedSubcategory === category ? "active" : ""
              }`}
              onClick={() => handleSubcategoryClick(category)}
              style={{ cursor: "pointer" }}
            >
              {category}
              {selectedSubcategory === category && (
                <i className="bi bi-check-circle ms-2"></i>
              )}
            </li>
          ))}
        </ul>
      );
    } else {
      return (
        <ul className="list-unstyled">
          {categories.map((category) => (
            <React.Fragment key={category.name}>
              <li className="d-flex justify-content-between">
                <span className="d-flex">
                  <div
                    className={`${
                      openCategory === category.name ? "rotate" : "still"
                    }`}
                  >
                    <i
                      className="bi bi-chevron-right"
                      onClick={() => handleCategoryClick(category.name)}
                      style={{ cursor: "pointer" }}
                    ></i>
                  </div>
                  <span className="ms-2">{category?.name}</span>
                </span>
                <span className="me-4">({category?.items?.length})</span>
              </li>
              {openCategory === category.name && (
                <ul className="ms-4">
                  {category.items.map((item, index) => (
                    <li
                      key={index}
                      className={`subcategory ${
                        selectedSubcategory === item ? "active" : ""
                      }`}
                      onClick={() => handleSubcategoryClick(item)}
                      style={{ cursor: "pointer" }}
                    >
                      {item}
                      {selectedSubcategory === item && (
                        <i className="bi bi-check-circle ms-2"></i>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </React.Fragment>
          ))}
        </ul>
      );
    }
  };

  return (
    <main className="dashboard main" id="main">
      {/* Cart Modal */}
      <Modal
        show={showCartModal}
        onHide={() => setShowCartModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>🛒 Cart Items</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {cartItems.length === 0 ? (
            <p className="text-center">No items in cart</p>
          ) : (
            cartItems.map((item) => (
              <div
                key={item.productNumber}
                className="d-flex align-items-center justify-content-between border rounded p-2 mb-2"
              >
                <div className="d-flex align-items-center gap-3">
                  <img
                    src={item.imageUrl}
                    alt={item.productName}
                    width={60}
                    height={60}
                    className="rounded"
                  />
                  <div>
                    <strong>{item.productName}</strong>
                    <div className="text-muted">Qty: {item.qty}</div>
                    <div className="text-muted">₹{item.price}</div>
                  </div>
                </div>

                <Trash2
                  size={25}
                  className="text-danger cart-remove-icon"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleRemoveFromCart(item)}
                />
              </div>
            ))
          )}
        </Modal.Body>

        <Modal.Footer>
          <button className="btnBack" onClick={() => setShowCartModal(false)}>
            Close
          </button>

          <button
            className="btnBack"
            onClick={() => {
              setOpenFromCart(true);
              setEquipmentData(null);
              setShowCartModal(false);
              setModalShowPurchase(true);
            }}
          >
            Create PR
          </button>
        </Modal.Footer>
      </Modal>

      <Layout />

      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            {/* Sticky Header */}
            <div className="catalog-sticky-header">
              <div className="catalog-header-left">
                <h2 className="mainTitle mb-1">Catalog</h2>
                <p className="subText mb-0">
                  {categoryTitle || "Browse materials"}
                </p>
              </div>

              <div className="catalog-header-actions">
                <button
                  className="cart-fab-inline"
                  onClick={() => setShowCartModal(true)}
                  title="View Cart"
                >
                  <i className="bi bi-cart3 fs-5"></i>
                  {cartItems.length > 0 && (
                    <span className="cart-fab-badge">{cartItems.length}</span>
                  )}
                </button>
              </div>
            </div>
            <hr />

            <Row>
              {/* Categories Sidebar */}
              <Col
                lg={2}
                className="d-flex flex-lg-column flex-xs-row flex-wrap"
                style={{ fontSize: "18px" }}
              >
                <Col xs={4} lg={12}>
                  <h5>Categories</h5>
                  {selectedSubcategory && (
                    <button
                      className="btn btn-sm btn-outline-secondary mb-3"
                      onClick={clearFilter}
                    >
                      Clear Filter: {selectedSubcategory} ✕
                    </button>
                  )}
                  {renderCategories()}
                  <hr className="d-lg-block d-none me-4" />
                </Col>
              </Col>

              {/* Products Grid */}
              <Col lg={10}>
                <Col
                  lg={12}
                  className="d-flex justify-content-between align-items-center mb-3"
                >
                  <div className="col-lg-3 col-md-3 col-sm-6">
                    <ComboboxField
                      label=""
                      placeholder="Sort the product"
                      data={sortDropDown}
                      id="sortProduct"
                      iconClassName="dropdownIcon"
                      name="sortProduct"
                      code="sortProductcode"
                      description="countryDesc"
                    />
                  </div>
                  <div className="d-flex gap-2 align-items-center ms-4">
                    <button
                      className={
                        getToggle
                          ? "active-grid-layout grid-layout"
                          : "grid-layout"
                      }
                      onClick={toggleRowProduct}
                    >
                      <i className="bi bi-grid-3x3-gap-fill fs-4"></i>
                    </button>
                    <button
                      className={
                        getToggle ? "grid-layout" : "active-grid-layout"
                      }
                      onClick={toggleColProduct}
                    >
                      <i className="bi bi-list-task fs-4"></i>
                    </button>
                    <ComboboxField
                      placeholder="Showing"
                      data={pagination}
                      id="pagination"
                      iconClassName="dropdownIcon"
                      name="pagination"
                      code="paginationcode"
                      description="countryDesc"
                    />
                  </div>
                </Col>

                {/* Products Display */}
                <div className="d-flex gap-4 flex-wrap justify-content-start mt-4">
                  {filteredProducts.length > 0 ? (
                    getToggle ? (
                      // ✅ GRID VIEW - FIXED
                      filteredProducts.map((items) => (
                        <Col
                          xs={12}
                          md={4}
                          lg={3}
                          className="product-width"
                          key={items.id}
                        >
                          <div className="product-grid">
                            <div className="product_img">
                              <img
                                src={items.imageUrl}
                                alt={items.productName}
                              />

                              {/* FREE DELIVERY Badge */}
                              <div className="free-delivery-badge">
                                <i className="bi bi-truck"></i>
                                <span>Free Delivery</span>
                              </div>

                              <div className="product_action_box">
                                <ul className="list_none pr_action_btn">
                                  <li className="add-to-cart">
                                    <p
                                      onClick={() => {
                                        setOpenFromCart(false);
                                        equipmentDetails(items);
                                      }}
                                    >
                                      <i className="bi bi-cart2"></i>
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      <i className="bi bi-shuffle"></i>
                                    </p>
                                  </li>
                                  <li>
                                    <p onClick={() => showProductDetail(items)}>
                                      <i className="bi bi-search"></i>
                                    </p>
                                  </li>
                                  <li>
                                    <p>
                                      <i className="bi bi-heart"></i>
                                    </p>
                                  </li>
                                </ul>
                              </div>
                            </div>

                            <div className="product_info px-2">
                              <h6 className="product_title">
                                <span onClick={() => showProductDetail(items)}>
                                  {items.productName}
                                </span>
                              </h6>

                              <div className="product_price d-flex align-items-center">
                                <span className="price">₹{items.price}</span>
                              </div>

                              <div className="rating_wrap d-flex align-items-center px-2">
                                <div className="rating">
                                  <div className="product_rate">
                                    <StarRating
                                      totalStars={5}
                                      fixedRating={items.rating}
                                      enableHover={false}
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="pr_switch_wrap d-flex flex-wrap justify-content-between px-2 pb-2">
                                <Row className="align-items-end w-100">
                                  <Col xs={12} className="mb-2">
                                    <InputField
                                      type="number"
                                      className="inputBox"
                                      label="Qty:"
                                      value={qtyMap[items.id] || 1}
                                      onChange={(e) =>
                                        setQtyMap((prev) => ({
                                          ...prev,
                                          [items.id]: Number(e.target.value),
                                        }))
                                      }
                                    />
                                  </Col>

                                  <Col xs={6} md={6} lg={6}>
                                    <button
                                      className="btnBack w-100"
                                      onClick={() => {
                                        setOpenFromCart(false);
                                        equipmentDetails(items);
                                      }}
                                    >
                                      <i className="bi bi-cart2"></i> Purchase
                                    </button>
                                  </Col>

                                  <Col xs={6} md={6} lg={6}>
                                    <button
                                      className="btnBack w-100"
                                      onClick={() =>
                                        handleAddToCart(
                                          items,
                                          qtyMap[items.id] || 1
                                        )
                                      }
                                    >
                                      🛒 Add to Cart
                                    </button>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </div>
                        </Col>
                      ))
                    ) : (
                      // LIST VIEW
                      filteredProducts.map((items) => (
                        <Col lg={12} key={items.id}>
                          <div className="product-row d-md-flex d-sm-block m-2">
                            <div className="product_img w-lg-25 w-sm-100">
                              <img
                                src={items.imageUrl}
                                alt="product"
                                style={{
                                  width: "200px",
                                  height: "150px",
                                  objectFit: "cover",
                                }}
                              />
                            </div>
                            <div className="d-sm-block d-lg-flex w-75 px-2 mt-2">
                              <Col xs={12} md={8} lg={8}>
                                <h6 className="product_title">
                                  <span
                                    onClick={() => showProductDetail(items)}
                                  >
                                    {items.productName}
                                  </span>
                                </h6>
                                <div className="product_price d-flex align-items-center">
                                  <span className="price">₹{items.price}</span>
                                </div>
                                <div className="rating_wrap d-flex">
                                  <div className="rating">
                                    <div className="product_rate">
                                      <StarRating
                                        totalStars={5}
                                        fixedRating={items.rating}
                                        enableHover={false}
                                      />
                                    </div>
                                  </div>
                                  <div className="free-delivery-badge">
                                    FREE DELIVERY
                                  </div>
                                </div>
                                <div className="pr_desc">
                                  <p className="m-0">{items.description}</p>
                                </div>
                              </Col>
                              <Col
                                xs={6}
                                md={4}
                                lg={4}
                                className="d-flex align-items-center justify-content-end mt-2"
                              >
                                <div className="pr_switch_wrap pb-2 d-flex flex-column justify-content-center">
                                  <div>
                                    <InputField
                                      type="number"
                                      className="inputBox"
                                      label="Qnt:"
                                      value={qtyMap[items.id] || 1}
                                      onChange={(e) =>
                                        setQtyMap((prev) => ({
                                          ...prev,
                                          [items.id]: Number(e.target.value),
                                        }))
                                      }
                                    />
                                  </div>
                                  <div className="list_product_action_box mt-2">
                                    <ul className="list_none pr_action_btn d-flex align-itmes-center gap-4 pb-2">
                                      <li>
                                        <button
                                          className="btnBack"
                                          onClick={() => {
                                            setOpenFromCart(false);
                                            equipmentDetails(items);
                                          }}
                                        >
                                          <i className="bi bi-cart2"></i>{" "}
                                          Purchase
                                        </button>
                                      </li>
                                      <li>
                                        <button
                                          className="btnBack"
                                          onClick={() =>
                                            handleAddToCart(
                                              items,
                                              qtyMap[items.id] || 1
                                            )
                                          }
                                        >
                                          🛒 Add to Cart
                                        </button>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </Col>
                            </div>
                          </div>
                        </Col>
                      ))
                    )
                  ) : (
                    <div className="alert alert-info w-100">
                      No products found in this category.
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      {/* Modals */}
      <CatalogMaterialDetailsModal
        show={modalShowDetailProduct}
        onHide={hideModal}
        product={modalProduct}
      />
      <MatrialCreatePo
        show={modalShowPurchase}
        onHide={hideModal}
        equipmentData={equipmentData}
        cartItems={cartItems}
        openFromCart={openFromCart}
      />
    </main>
  );
};

export default MaterialCatalogShopwise;
